
const Main = () => import('../../pages/main')

const SiteNetworkList = () => import('../../pages/SiteNetwork/SiteNetworkList')
const SiteAddContent = () => import('../../pages/SiteNetwork/SiteAddContent')
const AourceManagement = () => import('../../pages/SiteNetwork/AourceManagement')
const TaskList = () => import('../../pages/SiteNetwork/TaskList')


export default {
	path: '/siteNetwork',
	component: Main,
	meta: {
		requiresAuth: true,
		hidden: false,
		title: '站群管理',
		icon: 'icon-nav icon-nav-tool',
		sideNav: true
	},
	children: [
		{
			name: 'siteNetworkList',
			path: 'index',
			component: SiteNetworkList,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '文章管理'
			}
		},
        {
            name: 'siteAddContent',
            path: 'edit',
            component: SiteAddContent,
            meta: {
                requiresAuth: true,
                hidden: false,
                title: '文章编辑'
            }
        },
		// {
		// 	name: 'gourceManagement',
		// 	path: 'gourceManagement',
		// 	component: AourceManagement,
		// 	meta: {
		// 		requiresAuth: true,
		// 		hidden: false,
		// 		title: '数据源管理'
		// 	}
		// },
		// {
		// 	name: 'taskList',
		// 	path: 'taskList',
		// 	component: TaskList,
		// 	meta: {
		// 		requiresAuth: true,
		// 		hidden: false,
		// 		title: '抓取任务列表'
		// 	}
		// }
	]
}
